import React from "react"
import { EColumnSizing, IColumn, TwoColumnTextLayoutBlade } from "@organic-return/foundation-react/src/components/Blades/TwoColumnTextLayoutBlade"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"


const TwoColumnTextLayout = ({ module }) => {

    const fields = module.customFields

    const getImageSize = (imageSize: string) => {
        switch (imageSize) {
            case "3x2":
                return EWsrvTransform.cover3x2;
            case "16x2":
                return EWsrvTransform.cover16x9;
            case "3x4_headshot":
                return EWsrvTransform.thumb3x4;
            case "1x1_headshot":
                return EWsrvTransform.thumb1x1;
            default:
                return EWsrvTransform.cover4x3;
        }
    }

    let columnSizing: EColumnSizing
    switch (fields.columnSize) {
        case "25":
            columnSizing = EColumnSizing.left25
            break
        case "40":
            columnSizing = EColumnSizing.left40
            break
        case "60":
            columnSizing = EColumnSizing.left60
            break
        default:
            columnSizing = EColumnSizing.left50
            break
    }

    const leftCol: IColumn = {
        title: fields.leftColumnTitle,
        text: fields.leftColumnText,
        link: fields.leftColumnLink?.href && {
            label: fields.leftColumnLink.text,
            url: fields.leftColumnLink.href
        },
        image: fields.leftColumnImage?.url && {
            url: fields.leftColumnImage?.url
        },
        imagePreset: getImageSize(fields.leftColumnImageSize),
    }
    const rightCol: IColumn = {
        title: fields.rightColumnTitle,
        text: fields.rightColumnText,
        link: fields.rightColumnLink?.href && {
            label: fields.rightColumnLink.text,
            url: fields.rightColumnLink.href
        },
        image: fields.rightColumnImage?.url && {
            url: fields.rightColumnImage?.url
        },
        imagePreset: getImageSize(fields.rightColumnImageSize),
    }

    return (
        <TwoColumnTextLayoutBlade
            scaleImageOnHover={module.customFields.scaleImageOnHover == "true"}
            columnSizing={columnSizing}
            columnsWrapperClass="max-w-screen-xl"
            leftColumn={leftCol}
            rightColumn={rightCol}
        />
    )
}

export default TwoColumnTextLayout